export default "__VITE_ASSET__BKnYiKP___"